import {Component, Input} from '@angular/core';
import {Node} from "../../models/tree.model";

@Component({
  selector: 'app-tree-node',
  templateUrl: './tree-node.component.html',
  styleUrls: ['./tree-node.component.scss']
})
export class TreeNodeComponent<T extends Node> {
  @Input() node: T
  children: T[]

  getChildren(node: T): T[] {
    return []
  }
}
